import CurrencyKV from '@/constants/currencies';
import BigNumber from 'bignumber.js';
import { trim } from 'lodash';
import { v4 as uuidV1 } from 'uuid';

export const createUuid = (): string => uuidV1();

export const formatCurrency = (amount: number, currencyCode = 'HKD') => {
  if (CurrencyKV[currencyCode]) {
    currencyCode = CurrencyKV[currencyCode];
  }
  if (amount < 0) {
    return `-${currencyCode}${new BigNumber(Math.abs(amount)).toFormat(2)}`;
  }
  return `${currencyCode}${new BigNumber(amount).toFormat(2)}`;
};

export const handleNameDisplay = (text: string) => {
  if (text) {
    const value = trim(text.replace(/[^\u4e00-\u9fa50-9A-Za-z ]/g, ''));
    if (value) {
      const tArray = value.split(/\s+/);
      const first = tArray[0].toLocaleUpperCase();
      const end = tArray[tArray.length - 1].toLocaleUpperCase();

      if (tArray.length === 1) {
        if (first.charCodeAt(0) > 255) {
          return first.substring(first.length > 1 ? first.length - 2 : 0);
        }
        return first.charAt(0);
      }

      return `${first.charAt(0)}${end.charAt(0)}`;
    }
  }
};

/**
 * 在本地保存json对象
 * @param key 储存标识
 * @param json
 */
export const setLocalStorageJson = (key: string, json: any): void => {
  try {
    localStorage.setItem(key, JSON.stringify(json));
  } catch (error) {
    console.warn('[setLocalStorageJson] failed:', error);
  }
};

/**
 * 从本地获取json对象
 * @param key 储存标识
 */
export const getLocalStorageJson = (key: string): any => {
  try {
    const json = localStorage.getItem(key);
    if (!json) return undefined;
    return JSON.parse(json);
  } catch (error) {
    console.warn('[getLocalStorageJson] failed:', error);
    return undefined;
  }
};

/**
 * 在本地保存json对象
 * @param key 储存标识
 * @param json
 */
export const setSessionStorageJson = (key: string, json: any): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(json));
  } catch (error) {
    console.warn('[setSessionStorageJson] failed:', error);
  }
};

/**
 * 从本地获取json对象
 * @param key 储存标识
 */
export const getSessionStorageJson = (key: string): any => {
  try {
    const json = sessionStorage.getItem(key);
    if (!json) return undefined;
    return JSON.parse(json);
  } catch (error) {
    console.warn('[getSessionStorageJson] failed:', error);
    return undefined;
  }
};

export const plus = (
  num1: number,
  num2: number,
  decimal?: number | undefined
) => {
  let num: any = new BigNumber(num1).plus(num2);

  if (decimal !== undefined && decimal !== null) {
    num = num.toFixed(decimal);
  }

  return Number(num);
};

export const minus = (
  num1: number,
  num2: number,
  decimal?: number | undefined
) => {
  let num: any = new BigNumber(num1).minus(num2);

  if (decimal !== undefined && decimal !== null) {
    num = num.toFixed(decimal);
  }

  return Number(num);
};

export const times = (
  num1: number,
  num2: number,
  decimal?: number | undefined
) => {
  let num: any = new BigNumber(num1).times(num2);

  if (decimal !== undefined && decimal !== null) {
    num = num.toFixed(decimal);
  }

  return Number(num);
};

export const dividedBy = (
  num1: number,
  num2: number,
  decimal?: number | undefined
) => {
  let num: any = new BigNumber(num1).dividedBy(num2);

  if (decimal !== undefined && decimal !== null) {
    num = num.toFixed(decimal);
  }

  return Number(num);
};

export const handleNumber = (value: string | number, decimals = 2) => {
  let returnValue: React.Key = '--';
  const temp = new BigNumber(value);
  if (!temp.isNaN()) {
    returnValue = temp.toFormat(decimals, 1);
  }
  return returnValue;
};

export function findNode<T>(
  list: any[] = [],
  key: string,
  value: any,
  childrenKey = 'children'
): T | undefined {
  if (!(typeof key === 'string') || !Array.isArray(list)) {
    return undefined;
  }

  for (let i = 0; i < list.length; i++) {
    const node = list[i];
    // eslint-disable-next-line
    if (node[key] === value) {
      return node;
    } else if (node[childrenKey] && node[childrenKey].length > 0) {
      const tempNode = findNode<T>(node[childrenKey], key, value, childrenKey);
      if (tempNode) {
        return tempNode;
      }
    }
  }

  return undefined;
}

